import { i18nService } from "services";

export const convertMinutesToDate = (minutes: number) => {
  return new Date(minutes * 1000).toLocaleDateString(
    i18nService.currentLanguage,
    {
      year: "numeric",
      month: "long",
      day: "numeric",
    }
  );
};
